import { useRef } from "react";
import { Modal } from "./Modal";

type Props = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  tone?: "danger" | "primary";
  onConfirm(): void;
  onCancel(): void;
};

/** Ação destrutiva começa com o foco em Cancelar. onCancel roda uma vez (no evento close), nunca depois de confirmar (FE18). */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = "Cancelar",
  tone = "danger",
  onConfirm,
  onCancel,
}: Props) {
  const confirmed = useRef(false);
  return (
    <Modal
      open={open}
      title={title}
      onClose={() => {
        if (!confirmed.current) onCancel();
        confirmed.current = false;
      }}
      footer={
        <>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-autofocus={tone === "danger" ? "" : undefined}
            onClick={(e) => e.currentTarget.closest("dialog")?.close()}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`btn btn-${tone}`}
            data-autofocus={tone === "danger" ? undefined : ""}
            onClick={(e) => {
              const d = e.currentTarget.closest("dialog");
              confirmed.current = true;
              onConfirm();
              d?.close();
            }}
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      <p className="mb-0">{message}</p>
    </Modal>
  );
}
